import React from 'react';
import { getBrandPresenceSubTabClassName } from './BrandPresenceTabStyles';

export type GovernanceSwitchOption<TValue extends string> = {
  value: TValue;
  label: string;
};

export function GovernanceSegmentedSwitch<TValue extends string>({
  value,
  options,
  onChange,
  disabled,
}: {
  value: TValue;
  options: GovernanceSwitchOption<TValue>[];
  onChange: (value: TValue) => void;
  disabled?: boolean;
}) {
  return (
    <div className="inline-flex items-center gap-0.5 rounded-xl bg-slate-100/90 p-1">
      {options.map((option) => {
        const active = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            className={getBrandPresenceSubTabClassName(active, 'disabled:cursor-not-allowed disabled:opacity-50')}
            aria-pressed={active}
            onClick={() => onChange(option.value)}
            disabled={disabled}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
